// extracted by mini-css-extract-plugin
export var filterIncDec = "_dm-0";
export var leftBorder = "_dm-1";
export var rightBorder = "_dm-2";
export var stringInput = "_dm-3";